import Serializable from "@/core/misc/mixins/Serializable";
import PartnerRoleAccess from "@/domains/DeliveryTypes/PartnerRoleAccess";
import Utils from "@/core/utils/Utils";

class DeliveryType extends Serializable {

    public id: string;

    public name: string;

    public descriptionForSeller: string;
    public descriptionForBuyer: string;

    public isAccessibleBy: PartnerRoleAccess;

    toString() { return this.name }

    static fromServer(data: any, deliveryType = new DeliveryType()): DeliveryType {
        super.fromServer(data, deliveryType);

        if (Utils.isObject(data.isAccessibleBy)) { deliveryType.isAccessibleBy = PartnerRoleAccess.fromServer(data.isAccessibleBy); }

        return deliveryType;
    }

}

export default DeliveryType;
